import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import Testimonials from '../components/landing/Testimonials';
import Pricing from '../components/landing/Pricing';
import Footer from '../components/landing/Footer';
import { scrollToSection } from '../components/landing/SectionLink';
import usePageTitle from '../hooks/usePageTitle';

function LandingPage() {
  usePageTitle('Manage your chapter\'s academics');

  const { hash } = useLocation();

  // A section link from another route arrives here as '/#features'. The router
  // does not scroll for a hash, so this page does it.
  useEffect(() => {
    if (!hash) {
      return;
    }
    const target = document.getElementById(hash.slice(1));
    if (target) {
      scrollToSection(target);
    }
  }, [hash]);

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Features />
      <Testimonials />
      <Pricing />
      <Footer />
    </div>
  );
}

export default LandingPage;
